<template>
    <CardPage :section="13" :page="4">
        <p>
            Can you think of any other signs of a healthy relationship? Add them below:
        </p>
        <v-textarea outline label="Additional signs" :rows="2" auto-grow v-model="mySigns"></v-textarea>
    </CardPage>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
    computed: {
        mySigns: sync('section13/mySigns')
    }
};
</script>
